module.exports = __webpack_public_path__ + "static/media/papers.53609baf.svg";